import React from "react";
import { Box, useEditableControls } from "@chakra-ui/react";
import { CheckIcon, XMarkIcon, PencilIcon } from "@heroicons/react/24/outline";
import { IconButton } from "./icon-button";
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => { };
export function EditableControls({ size }) {
    const { isEditing, getSubmitButtonProps, getCancelButtonProps, getEditButtonProps, } = useEditableControls();
    return isEditing ? (React.createElement(Box, { display: "flex", gap: 1 },
        React.createElement(IconButton, { size: size, "aria-label": "Submit", icon: CheckIcon, onClick: noop, ...getSubmitButtonProps() }),
        React.createElement(IconButton, { "aria-label": "Cancel", size: size, icon: XMarkIcon, onClick: noop, ...getCancelButtonProps() }))) : (React.createElement(IconButton, { "aria-label": "Edit", size: size, icon: PencilIcon, onClick: noop, ...getEditButtonProps() }));
}
